import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Building2, GripVertical, Pencil } from "lucide-react";

import { BACKEND } from "../lib/backend";

export default function SortableSlideItem({ slide, index, tier, isSelected, baseDuration, onSelect, onEditImage }) {
  const {
    attributes, listeners, setNodeRef, transform, transition, isDragging,
  } = useSortable({ id: slide.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    borderLeft: tier ? `3px solid ${tier.color}` : undefined,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      data-testid={`slide-item-${index}`}
      onClick={onSelect}
      className={`group w-full text-left bg-zinc-900 border rounded-md p-2 flex items-center gap-2 transition-colors cursor-pointer ${
        isSelected ? "border-blue-500" : "border-zinc-800 hover:border-zinc-700"
      }`}
    >
      <button
        {...attributes}
        {...listeners}
        data-testid={`slide-drag-handle-${index}`}
        onClick={(e) => e.stopPropagation()}
        className="text-zinc-600 hover:text-zinc-300 cursor-grab active:cursor-grabbing p-0.5"
        aria-label="Drag to reorder"
      >
        <GripVertical className="w-3.5 h-3.5" />
      </button>
      <div className="relative w-10 h-10 rounded bg-zinc-950 border border-zinc-800 grid place-items-center overflow-hidden shrink-0">
        {slide.image_url ? (
          <img src={`${BACKEND}${slide.image_url}`} alt="" className="w-full h-full object-contain" />
        ) : (
          <Building2 className="w-4 h-4 text-zinc-600" />
        )}
        {slide.image_url && onEditImage && (
          <button
            type="button"
            data-testid={`slide-edit-image-${index}`}
            onClick={(e) => { e.stopPropagation(); onEditImage(slide.id); }}
            className="absolute inset-0 grid place-items-center bg-zinc-950/70 opacity-0 group-hover:opacity-100 transition-opacity text-blue-300 hover:text-blue-200"
            aria-label="Edit image"
            title="Edit image"
          >
            <Pencil className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm truncate">{slide.company_name || "Untitled"}</div>
        <div className="text-[10px] text-zinc-500 truncate">
          {tier
            ? `${tier.name} · ${(tier.duration_multiplier * baseDuration).toFixed(1)}s`
            : "No tier"}
        </div>
      </div>
    </div>
  );
}
